export default [
  {
    path: '/user',
    component: () => import('./views/Index'),
    name: 'user',
    redirect: { name: 'user-list' },
    children: [
      {
        path: '',
        name: 'user-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'management-user',
        },
      },
      {
        path: 'detail/:user_id',
        name: 'user-detail',
        component: () => import('./views/Detail'),
        meta: {
          resource: 'management-user',
        },
      },
    ],
  },
]
